<div class="text-dynamic-content" [innerHTML]="component()?.content"></div>
